<script setup lang="ts">
// Передаёт странице её маршрут (см. runtime/route.ts): поля читаются из свойства, которое у уходящей страницы больше не меняется.
import { provide } from 'vue';
import type { RouteLocationNormalizedLoaded } from 'vue-router';
import { pageRouteKey } from '@/runtime/route';

const props = defineProps<{ route: RouteLocationNormalizedLoaded }>();
provide(pageRouteKey, new Proxy({} as RouteLocationNormalizedLoaded, { get: (_target, key) => props.route[key as keyof RouteLocationNormalizedLoaded] }));
</script>

<template>
  <slot />
</template>
